<template>
    <login-layout>
        <form @submit.prevent="activate" novalidate>
            <h5 class="c_white t_center t_uppercase">{{ $t('profile') }}</h5>
            <div class="row">
                <div class="col-xs-12" :class="{'has-error': errors['email']}">
                    <input class="custom_input form-control m-b-5" v-model="record.email" type="email" autocomplete="false" :placeholder="`* ${$t('email')}`" v-pml-focus>
                    <span class="error" v-if="errors['email']">{{ errors['email'][0] }}</span>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-12" :class="{'has-error': errors['password']}">
                    <input class="custom_input form-control m-b-5" v-model="record.password" type="password" :placeholder="`* ${$t('choose_a_password')}`">
                    <span class="error" v-if="errors['password']">{{ errors['password'][0] }}</span>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-12" :class="{'has-error': errors['password_confirmation']}">
                    <input class="custom_input form-control m-b-5" v-model="record.password_confirmation" type="password" :placeholder="`* ${$t('confirm_new_password')}`">
                    <span class="error" v-if="errors['password_confirmation']">{{ errors['password_confirmation'][0] }}</span>
                </div>
            </div>
            <h5 class="c_white t_center t_uppercase m-t-30">{{ $t('company') }}</h5>
            <div class="row">
                <div class="col-xs-12" :class="{'has-error': errors['company']}">
                    <input class="custom_input form-control" v-model="record.company" type="text" :placeholder="`* ${$t('company')}`">
                    <span class="error" v-if="errors['company']">{{ errors['company'][0] }}</span>
                </div>
            </div>
            <h5 class="c_white t_center t_uppercase m-t-30">{{ $t('base_currency') }}</h5>
            <div class="row">
                <div class="col-xs-12" :class="{'has-error': errors['currency_id']}">
                    <pml-select v-model="record.currency_id" :options="currencies"></pml-select>
                    <span class="error" v-if="errors['currency_id']">{{ errors['currency_id'][0] }}</span>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-12">
                    <button v-pml-block="isLoading" class="btn_login btn btn-block text-uppercase m-t-30" type="submit">{{ $t('account_activate') }}</button>
                </div>
            </div>
        </form>
    </login-layout>
</template>

<script>
    import axios from 'axios'
    import client from 'utils/http'
    import { mapActions, mapGetters } from 'vuex'
    import { accountActivate } from 'services/company'
    import { trans } from 'utils/helpers/translation'

    export default {
        name: 'Start',
        data () {
            return {
                record: {
                    token: this.$route.params.token
                },
                errors: [],
                isLoading: false,
                currencies: [
                    { id: 1, name: trans('_currencies.brazilian_real') },
                    { id: 2, name: trans('_currencies.euro') },
                    { id: 3, name: trans('_currencies.us_dollar') },
                    { id: 4, name: trans('_currencies.british_pound') },
                    { id: 5, name: trans('_currencies.australian_dollar') },
                    { id: 6, name: trans('_currencies.chinese_yuan') },
                    { id: 7, name: trans('_currencies.japanese_yen') },
                    { id: 8, name: trans('_currencies.canadian_dollar') },
                    { id: 9, name: trans('_currencies.indian_rupee') },
                    { id: 10, name: trans('_currencies.argentine_peso') },
                    { id: 11, name: trans('_currencies.mexican_peso') },
                    { id: 12, name: trans('_currencies.nz_dollar') },
                    { id: 13, name: trans('_currencies.south_africa_rand') },
                    { id: 14, name: trans('_currencies.swiss_franc') }
                ]
            }
        },
        created () {
            this.switchLanguage(this.$route.params.lang)

            if (typeof this.tenant.id !== 'undefined')
                this.logout()
        },
        computed: {
            ...mapGetters({
                'tenant': 'getTenant'
            })
        },
        methods: {
            ...mapActions([ 'attemptLogin', 'initStore', 'logout' ]),
            switchLanguage (lang) {
                window.localStorage.setItem('pml_lang', lang)
                axios.defaults.headers.common['Accept-Language'] = lang
                client.defaults.headers.common['Accept-Language'] = lang
                this.$i18n.locale = lang
            },
            activate () {
                this.isLoading = true

                accountActivate(this.record)
                    .then(() => {
                        window.localStorage.setItem('pml_tour', true)
                        this.doLogin()
                    })
                    .catch(error => {
                        this.errors = error.response.data.errors || []
                        this.isLoading = false
                    })
            },
            doLogin () {
                this.attemptLogin(this.record)
                    .then(() => this.fetchData())
                    .catch(error => {
                        this.errors = error.response.data.errors || []
                        this.isLoading = false
                    })
            },
            fetchData () {
                this.initStore()
                    .then(() => {
                        this.$router.push({ name: 'dashboard.index' })
                        this.isLoading = false
                    })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/start/components/Main.vue